import { create } from "zustand";

export type ToastType = "success" | "error" | "info";

export type ToastItem = {
    id: string;
    type: ToastType;
    title?: string;
    message: string;
    createdAt: number;
    durationMs?: number; // default 3500
};

type ToastStore = {
    items: ToastItem[];
    push: (t: Omit<ToastItem, "id" | "createdAt">) => string;
    remove: (id: string) => void;
    clear: () => void;
};

function uid() {
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
}

export const useToastStore = create<ToastStore>((set, get) => ({
    items: [],

    push: (t) => {
        const id = uid();
        const toast: ToastItem = {
            id,
            createdAt: Date.now(),
            durationMs: t.durationMs ?? 3500,
            ...t,
        };

        set((s) => ({
            items: [toast, ...s.items].slice(0, 4), // максимум 4 тоста
        }));

        // автоудаление
        window.setTimeout(() => {
            const exists = get().items.some((x) => x.id === id);
            if (exists) get().remove(id);
        }, toast.durationMs);

        return id;
    },

    remove: (id) => set((s) => ({ items: s.items.filter((x) => x.id !== id) })),

    clear: () => set({ items: [] }),
}));
